module.exports = __webpack_public_path__ + "img/banner2.dae6a5bf.png";